import { render, staticRenderFns } from "./CodeInline.vue?vue&type=template&id=42773780&scoped=true&"
import script from "./CodeInline.vue?vue&type=script&lang=js&"
export * from "./CodeInline.vue?vue&type=script&lang=js&"
import style0 from "./CodeInline.vue?vue&type=style&index=0&id=42773780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42773780",
  null
  
)

export default component.exports